/*
 * Copyright (c) 2023 Bolmate B.V.
 */

export const DEFAULT_MAIL_TEMPLATE =
    "<html lang='nl'><body><p>Beste {klant_naam},</p><p>Bij deze de BTW factuur voor uw Bol bestelling ({order_id}) bij {bedrijf_naam}.</p><br><p>Met vriendelijke groet,</p><p>{bedrijf_naam}</p></body></html>";
